export const EXPRESSION_CHECK_URL = "https://calendly.com/philsconversation/expression-gap";

export function expressionCheckPath(lang: "en" | "de") {
  return lang === "de" ? "/de/expression-check" : "/expression-check";
}

export function expressionCheckBookingUrl(lang: "en" | "de") {
  return `${EXPRESSION_CHECK_URL}?locale=${lang}`;
}

export const OPEN_COACHING_GUIDE_EVENT = "open-coaching-guide";
/** Preserve click analytics without treating a click as a completed booking. */
export function trackBookingCta() {
  (window as any).dataLayer?.push({ event: "booking_cta_click" });
}

// Kept for the unmounted legacy dialog until its source is retired.
export const OPEN_BOOKING_INTAKE_EVENT = "open-booking-intake";

export interface ExpressionCheckContact {
  name: string;
  email: string;
}

/**
 * Calendly handover: only the built-in name/email fields are prefilled. The
 * intake questions were removed from the Calendly event (Oct 2026) because the
 * branded intake sequence already captures those answers and saves them to the
 * database, so no a1..a3 custom-answer params are sent.
 */
export function expressionCheckPrefillUrl(lang: "en" | "de", a: ExpressionCheckContact) {
  const params = new URLSearchParams({ locale: lang });
  if (a.name) params.set("name", a.name);
  if (a.email) params.set("email", a.email);
  return `${EXPRESSION_CHECK_URL}?${params.toString()}`;
}

/** Inline Calendly embed URL; embed_domain lets Calendly post booking events back to this page. */
export function calendlyInlineUrl(lang: "en" | "de", host: string) {
  const params = new URLSearchParams({ locale: lang, embed_domain: host, embed_type: "Inline", hide_gdpr_banner: "1" });
  return `${EXPRESSION_CHECK_URL}?${params.toString()}`;
}
